import TargetNumberForm from './_form'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    TargetNumberForm
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('targetNumbers.edit.title'))
        this.loadData()
      }
    }
  },

  methods: {
    loadData() {
      this.ready = false
      API.targetNumbers.show(this.$route.params.id).then(response => {
        console.log(response)
        this.data = response
        this.ready = true

        this.$setBreadcrumbs([
          {label: this.$t('breadcrumbs.targetNumbers.index'), route: {name: 'target-numbers-index'}},
          {label: this.$t('breadcrumbs.targetNumbers.edit', {name: this.data.name}), route: {}}
        ])
      })
    },

    updateTargetNumbers(data) {
      API.targetNumbers.update(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('targetNumbers.edit.succesfullyUpdated'))
        this.$router.push({name: 'target-numbers-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
